import type { ComponentType, FC } from "react";
import { Fragment } from "react";

import classNames from "classnames";

import { useConfig } from "@jti/app-context/useConfig";
import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { CardGeneric } from "@jti/ui/components/CardGeneric";
import { IconBannerCard } from "@jti/ui/components/IconBannerCard";

import useLoggedUser from "../../hooks/useLoggedUser";

import styles from "./ReferAFriend.module.scss";

export type StepListType = Array<{
  title: string;
  text: string;
  details?: string;
  imgEx?: string;
  imgRef: string;
}>;

export type ReferAFriendProps = {
  variant?: "raf" | "hiw";
  title: string;
  subtitle: string;
  subtitleDetails?: string;
  componentId?: string;
  registerUrl: string;
  registerTitle: string;
  signInUrl: string;
  signInTitle: string;
  stepslist: StepListType;
  stepslistloggedout: StepListType;
  isInEditor?: boolean;
  isLegacyStyled?: boolean;
};

export const ReferAFriend: FC<ReferAFriendProps> = ({
  variant = "raf",
  title,
  subtitle,
  subtitleDetails,
  componentId,
  registerUrl,
  registerTitle,
  signInUrl,
  signInTitle,
  stepslist = [],
  stepslistloggedout = [],
  isInEditor,
  isLegacyStyled,
}) => {
  const [isLogged] = useLoggedUser();
  const { isReferralOn } = useConfig();
  const referVariant = variant === "raf";
  const activeStepslist = referVariant ? stepslist : isLogged ? stepslist : stepslistloggedout;

  const showActions = referVariant && !isLogged;

  if (!isReferralOn && !isInEditor) {
    return null;
  }

  return (
    // TODO: Remove legacy class names once no longer used in AEM
    <div
      className={classNames({ [styles.legacyStyle]: isLegacyStyled, "light-theme": isLegacyStyled })}
      id={componentId}
    >
      <CardGeneric
        title={title}
        secondaryTitle={subtitle}
        {...(!referVariant && { description: subtitleDetails })}
        {...(showActions && {
          primaryLabel: registerTitle,
          primaryHref: registerUrl,
          secondaryLabel: signInTitle,
          secondaryHref: signInUrl,
        })}
        data-testid="refer-a-friend-card"
      >
        <div className={styles.tilesContainer} data-testid="refer-a-friend-list">
          {activeStepslist.map(({ title, text, details, imgRef, imgEx }, index, array) => {
            const Image: ComponentType = () => <img className={styles.image} src={imgRef} alt={title} />;
            const isLast = index === array.length - 1;
            return (
              <Fragment key={title}>
                <div className={styles.iconBannerWrapper}>
                  <IconBannerCard title={title} description={text} icon={Image} caption={details} image={imgEx} />
                </div>
                {!isLast && <LongArrowForwardIcon className={styles.forwardArrow} />}
              </Fragment>
            );
          })}
        </div>
      </CardGeneric>
    </div>
  );
};
